import { Component, Input } from '@angular/core';
import { GenerateAnnexPreviewRequest } from 'src/app/contracts/requests/annexes/generate-annex-preview-request';
import { AnnexDetailsAnnexEntry, AnnexDetailsWorkerAgreementEntry } from 'src/app/models/dtos/annexes/annex-details-dto';
import { EmploymentAgreementDetailsDto } from 'src/app/models/dtos/employment-agreement-details-dto';
import { WorkerAgreementForAnnexDto } from 'src/app/models/dtos/worker-agreements/worker-agreement-for-annex-dto';

@Component({
  selector: 'app-summary-step',
  templateUrl: './summary-step.component.html',
  styleUrls: ['./summary-step.component.scss'],
  standalone: false,
})
export class SummaryStepComponent {
  @Input() mode: 'summary' | 'details' = 'summary';
  @Input() agreement: EmploymentAgreementDetailsDto | AnnexDetailsWorkerAgreementEntry;
  @Input() annexData: GenerateAnnexPreviewRequest | AnnexDetailsAnnexEntry;
  @Input() dataForAnnex: WorkerAgreementForAnnexDto | AnnexDetailsWorkerAgreementEntry;
}
